var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMinusButtonActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 87.5,
    height: 156.257,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "minusButtonActive_svg__a",
    x: 0,
    y: 0,
    width: 87.5,
    height: 156.257,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#cbcbcb",
    floodOpacity: 0.549
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": ".pressed-image"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(.002)",
    filter: "url(#minusButtonActive_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u5408\\u4F53 13",
    d: "M32.339 147.87L3.073 108.112a11.824 11.824 0 01-2.354-7.366 15.993 15.993 0 01-.716-4.747v-80a16 16 0 0116-16h52a16 16 0 0116 16v80a15.993 15.993 0 01-.716 4.747 11.824 11.824 0 01-2.354 7.366L51.667 147.87a11.926 11.926 0 01-9.664 4.886 11.926 11.926 0 01-9.664-4.886z",
    fill: "#b9f6ca"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u7DDA 124",
    fill: "none",
    stroke: "#000",
    strokeWidth: 8,
    d: "M24.902 104h30"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinusButtonActive);
export default __webpack_public_path__ + "static/media/minusButtonActive.8a8b666f59e052ae.svg";
export { ForwardRef as ReactComponent };